import React from 'react'
import get from 'lodash/get'
import Helmet from 'react-helmet'
import { connect } from 'react-redux'

class Login extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      email: '',
      password: '',
      newPassword: '',
    }
    this._onSubmit = this._onSubmit.bind(this)
    this._onSubmitNewPassword = this._onSubmitNewPassword.bind(this)
    this._onChange = this._onChange.bind(this)
  }

  _onSubmit(event) {
    event.preventDefault()
    this.props.login(this.state)
  }

  _onSubmitNewPassword(event) {
    event.preventDefault()
    const { user } = this.props

    this.props.newPassword({ user, ...this.state })
  }

  _onChange(field, event) {
    this.setState({ [field]: event.target.value })
  }

  render() {
    const site = get(this, 'props.data.site.siteMetadata')
    const { user, userChallenge, loginError } = this.props
    const onChange = field => event => this._onChange(field, event)

    if (user !== null) {
      return (
        <div className="container">
          <section>
            <p className="lead">Du är inloggad som {user.username}.</p>
          </section>
        </div>
      )
    }

    if (userChallenge === 'NEW_PASSWORD_REQUIRED') {
      return (
        <div>
          <div className="container">
            <section>
              <div className="container mb-4">
                <p className="lead">Inloggning till interninfo.</p>
              </div>
              <div className="container">
                <form onSubmit={this._onSubmitNewPassword}>
                  <div className="form-row">
                    <div className="form-group col-md-6">
                      <label htmlFor="inputNewPassword">Nytt lösenord</label>
                      <input
                        onChange={onChange('newPassword')}
                        type="password"
                        className="form-control"
                        id="inputNewPassword"
                        placeholder="Nytt lösenord"
                      />
                    </div>
                  </div>
                  <button type="submit" className="btn btn-primary mr-2">
                    Spara nytt lösenord
                  </button>
                </form>
              </div>
            </section>
          </div>
        </div>
      )
    }

    const error = loginError ? (
      <div className="alert alert-danger mt-2" role="alert">
        {loginError}
      </div>
    ) : (
      []
    )

    return (
      <div>
        <div className="container">
          <section>
            <div className="container mb-4">
              <p className="lead">Inloggning till interninfo.</p>
            </div>
            <div className="container">
              <form onSubmit={this._onSubmit}>
                <div className="form-row">
                  <div className="form-group col-md-6">
                    <label htmlFor="inputEmail4">Epost</label>
                    <input
                      onChange={onChange('email')}
                      //type="email"
                      className="form-control"
                      id="inputEmail4"
                      placeholder="Epost"
                    />
                  </div>
                  <div className="form-group col-md-6">
                    <label htmlFor="inputPassword4">Lösenord</label>
                    <input
                      onChange={onChange('password')}
                      type="password"
                      className="form-control"
                      id="inputPassword4"
                      placeholder="Lösenord"
                    />
                  </div>
                </div>
                <button type="submit" className="btn btn-primary mr-2">
                  Logga in
                </button>
                {error}
                <div className="alert alert-light mt-2" role="alert">
                  Är du boende och vill ha inloggning? Kontakta ...
                </div>
              </form>
            </div>
          </section>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return state
}

const mapDispatchToProps = dispatch => {
  return {
    login: data => {
      return dispatch({ type: 'LOGIN_REQUESTED', ...data })
    },
    newPassword: data => {
      return dispatch({ type: 'NEW_PASSWORD', ...data })
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Login)

export const pageQuery = graphql`
  query LoginQuery {
    site {
      siteMetadata {
        title
        description
        url: siteUrl
        author
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/inloggning.js